import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";

import {
  PostWidgetAnalysisConfigPayload,
  PostWidgetAnalysisResponse,
  PostWidgetDefaultConfigPayload,
  PostWidgetDefaultConfigResponse
} from "@/types/widget";

import { postWidgetAnalysisConfig, postWidgetDefaultConfig } from "./widgetAPI";

export const useGetWidgetAnalysisConfig = (
  payload: PostWidgetAnalysisConfigPayload,
  options?: Omit<
    UseQueryOptions<PostWidgetAnalysisResponse, Error>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["widgetAnalysis", payload],
    queryFn: () => postWidgetAnalysisConfig(payload),
    ...options
  });

export const useMutateGetWidgetDefaultConfig = (
  options?: Omit<
    UseMutationOptions<
      PostWidgetDefaultConfigResponse,
      Error,
      PostWidgetDefaultConfigPayload
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation({
    mutationKey: ["widgetDefaultConfig"],
    mutationFn: (body: PostWidgetDefaultConfigPayload) =>
      postWidgetDefaultConfig(body),
    ...options
  });

export const useQueryGetWidgetDefaultConfig = (
  payload: PostWidgetDefaultConfigPayload,
  options?: Omit<
    UseQueryOptions<PostWidgetDefaultConfigResponse, Error>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["widgetDefaultConfig", payload],
    queryFn: () => postWidgetDefaultConfig(payload),
    ...options
  });
